/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const HOLDER_CAN_ABILITY = [
  //Route Access
  ['read', 'MyAccount'],
  ['read', 'OrganizationProfile'],
  ['read', 'MyProfile'],
  ['read', 'OrgCompliance'],
  ['read', 'Analytics'],
  ['read', 'Distillers'],
];

export const HOLDER_CANNOT_ABILITY = [
  //Route Access Denial
  //  ["read", "Button"],
];
